import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SuiIconButtonComponent } from '@stride-ui/components';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService } from '../dialog/dialog.service';
import {
  InfoDialogComponent,
  InfoDialogData,
} from '../info-dialog/info-dialog.component';

@Component({
  selector: 'tnq-info-button',
  imports: [SuiIconButtonComponent, TranslateModule],
  templateUrl: './info-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info-button.component.scss',
})
export class InfoButtonComponent {
  readonly title = input.required<string>();
  readonly message = input.required<string>();
  readonly closeLabel = input<string>('global.close');
  readonly ariaLabel = input<string>('global.more_info');
  readonly size = input<'xs' | 'sm' | 'md' | 'lg'>('sm');

  private readonly dialogService = inject(DialogService);

  open(): void {
    const data: InfoDialogData = {
      title: this.title(),
      message: this.message(),
      closeLabel: this.closeLabel(),
    };
    this.dialogService.open(InfoDialogComponent, { data });
  }
}
